// Portfolio Mock Data - Real content (Gauransh Jaroli)

export const personalInfo = {
  name: "Gauransh Jaroli",
  role: "Software Engineer | Full-Stack Developer",
  summary:
    "Software Engineer focused on building production-grade web applications with real-world business use cases. Experienced in frontend systems, authentication flows, admin dashboards, and debugging complex integration issues across modern tech stacks.",
  email: "gauranshjaroli@gmail.com", // change if needed
  linkedin: "https://www.linkedin.com/in/gauransh-jaroli-24a057272/",
  github: "https://github.com/gauranshjaroli", // change if private
  location: "Udaipur, Rajasthan, India",
  resumeLink: "/resume.pdf",
};

export const skills = [
  { name: "React", icon: "Code2" },
  { name: "Next.js", icon: "Layers" },
  { name: "JavaScript (ES6+)", icon: "FileCode" },
  { name: "Node.js", icon: "Server" },
  { name: "FastAPI", icon: "Server" },
  { name: "MongoDB", icon: "Database" },
  { name: "PostgreSQL", icon: "HardDrive" },
  { name: "Supabase", icon: "Database" },
  { name: "Tailwind CSS", icon: "Palette" },
];

export const projects = [
  {
    id: 1,
    title: "Anand Fashion",
    description:"Built a scalable e-commerce website handling product inventory with optimized image loading & mobile-first UI. Focused on performance, clean product browsing,& smooth user experience to help customers explore products easily and increase engagement.",
    
    techStack: ["Next.js", "MongoDB", "Tailwind"],
    category: "Client",
    link: "https://www.anandfashionudaipur.com",
    featured: true,
  },
  {
    id: 2,
    title: "Him Cream Naturals",
    description:"Developed a QR-based ordering system where customers can scan and directly browse products on their phone. Designed a simple and fast flow to reduce manual effort and improve customer experience at the store.",
    techStack: ["React", "Node.js"],
    category: "Client",
    link: "https://www.himcreamnaturals.com",
    featured: true,
  },
  {
    id: 3,
    title: "SipCrunch",
    description:"Created a restaurant QR ordering system with table-based flow, allowing customers to order without waiting for staff. Built for real usage with focus on speed, usability, and reducing operational workload.",
    techStack: ["React", "MongoDB"],
    category: "Client",
    link: "https://sipcrunchweb-v2.vercel.app",
    featured: true,
  },
  
  {
    id: 5,
    title: "Bullet Raja",
    description: "Developed a showroom website focused on branding and product display. Emphasized modern UI and clear navigation to improve customer trust and showroom visibility online.",
    techStack: ["React"],
    category: "Client",
    link: "https://bulletrajweb.vercel.app",
  },
  {
    id: 6,
    title: "Strong Fit",
    description: "Fitness landing page.",
    techStack: ["Next.js"],
    category: "Client",
    link: "https://strongfitweb.vercel.app",
  },
  {
    id: 7,
    title: "Saraswati Hospital",
    description: "Hospital website.",
    techStack: ["React"],
    category: "Client",
    link: "https://saraswatihospitalweb.vercel.app",
  },
  {
    id: 8,
    title: "Jitendra Hair Salon",
    description: "Salon business website.",
    techStack: ["React"],
    category: "Client",
    link: "https://jitendrahairsalon.vercel.app",
  },
  {
    id: 9,
    title: "Oswal Sabha",
    description: "Community website.",
    techStack: ["React"],
    category: "Client",
    link: "https://oswalsabhaweb.vercel.app",
  },
  {
    id: 10,
    title: "Kalyan Paints",
    description: "Business catalog website.",
    techStack: ["React"],
    category: "Client",
    link: "https://kalyanpaintsweb.vercel.app",
  },
  {
    id: 11,
    title: "ParshWebCraft",
    description: "Agency website for lead generation.",
    techStack: ["Next.js", "Supabase"],
    category: "Product",
    link: "https://www.parshwebcraft.in",
  },
  {
    id: 12,
    title: "ParshVyapar",
    description: "GST billing SaaS system.",
    techStack: ["FastAPI", "React"],
    category: "Product",
    link: "https://www.parshvyapar.in/",
  },
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "Contact", path: "/contact" },
];
